import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed')({
  beforeLoad: ({ context, location }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          // Save current path for redirect after login (relative path only)
          redirect: location.pathname + location.searchStr,
        },
      })
    }

    // Block non-admin routes during maintenance mode
    const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'
    const isAdminRoute = location.pathname.startsWith('/admin')

    if (isMaintenanceMode && !isAdminRoute) {
      throw redirect({ to: '/maintenance' })
    }
  },
  component: () => <Outlet />,
})
